const { GRAPH_HOST } = require("../constants");
const { getTokenSubset } = require("./exchange");
const {
  masterChefV1PairAddressesQuery,
  masterChefV1SushiPerBlockQuery,
  masterChefV1TotalAllocPointQuery,
  masterChefV2PairAddressesQuery,
  miniChefPairAddressesQuery,
  miniChefPoolsQuery,
  poolsQuery,
  poolsV2Query,
} = require("../queries");
const { request } = require("graphql-request");
const { concat } = require("lodash");

const MINICHEF = {
  polygon: "sushiswap/matic-minichef",
  xdai: "sushiswap/xdai-minichef",
  harmony: "sushiswap/harmony-minichef",
  arbitrum: "matthewlilley/arbitrum-minichef",
  celo: "sushiswap/celo-minichef-v2",
  moonriver: "sushiswap/moonriver-minichef",
  fuse: "sushiswap/fuse-minichef",
  fantom: "sushiswap/fantom-minichef",
  moonbeam: "sushiswap/moonbeam-minichef",
};

const Chef = {
  MASTERCHEF: 0,
  MASTERCHEF_V2: 1,
  MINICHEF: 2,
  OLD_FARMS: 3,
};

const OLD_MINICHEF = {
  celo: "sushiswap/celo-minichef",
};

// @ts-ignore TYPE NEEDS FIXING
const miniChef = async (query, network = "ethereum", variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[network]}/subgraphs/name/${MINICHEF[network]}`, query, variables);

// @ts-ignore TYPE NEEDS FIXING
const oldMiniChef = async (query, network = "ethereum") =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[network]}/subgraphs/name/${OLD_MINICHEF[network]}`, query);

const MASTERCHEF_V2 = {
  ethereum: "sushiswap/master-chefv2",
};

// @ts-ignore TYPE NEEDS FIXING
const masterChefV2 = async (query, network = "ethereum", variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[network]}/subgraphs/name/${MASTERCHEF_V2[network]}`, query, variables);

const MASTERCHEF_V1 = {
  ethereum: "sushiswap/master-chef",
};

// @ts-ignore TYPE NEEDS FIXING
const masterChefV1 = async (query, network = "ethereum", variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[network]}/subgraphs/name/${MASTERCHEF_V1[network]}`, query, variables);

const getMasterChefV1TotalAllocPoint = async () => {
  const {
    masterChef: { totalAllocPoint },
  } = await masterChefV1(masterChefV1TotalAllocPointQuery);
  return totalAllocPoint;
};

const getMasterChefV1SushiPerBlock = async () => {
  const {
    masterChef: { sushiPerBlock },
  } = await masterChefV1(masterChefV1SushiPerBlockQuery);
  return sushiPerBlock / 1e18;
};

const getMasterChefV1PairAddreses = async () => {
  const { pools } = await masterChefV1(masterChefV1PairAddressesQuery);
  return pools;
};

const getMasterChefV2PairAddreses = async () => {
  const { pools } = await masterChefV2(masterChefV2PairAddressesQuery);
  return pools;
};

const getMiniChefPairAddreses = async (network = "ethereum") => {
  console.debug("getMiniChefPairAddreses");
  const { pools } = await miniChef(miniChefPairAddressesQuery, network);
  return pools;
};

const getMasterChefV1Farms = async (variables = undefined) => {
  const { pools } = await masterChefV1(poolsQuery, undefined, variables);
  return pools.map((pool) => ({ ...pool, chef: Chef.MASTERCHEF }));
};

const getMasterChefV2Farms = async (variables = undefined) => {
  const { pools } = await masterChefV2(poolsV2Query, undefined, variables);

  const tokens = await getTokenSubset("ethereum", {
    // @ts-ignore TYPE NEEDS FIXING
    tokenAddresses: Array.from(pools.map((pool) => pool.rewarder.rewardToken)),
  });

  // @ts-ignore TYPE NEEDS FIXING
  return pools.map((pool) => ({
    ...pool,
    chef: Chef.MASTERCHEF_V2,
    rewardToken: {
      // @ts-ignore TYPE NEEDS FIXING
      ...tokens.find((token) => token.id === pool.rewarder.rewardToken),
    },
  }));
};

const getOldMiniChefFarms = async (network = "ethereum") => {
  const { pools } = await oldMiniChef(miniChefPoolsQuery, network);
  return pools.map((pool) => ({ ...pool, chef: Chef.OLD_FARMS }));
};

const getMiniChefFarms = async (network = "ethereum", variables = undefined) => {
  const { pools } = await miniChef(miniChefPoolsQuery, network, variables);
  return pools.map((pool) => ({ ...pool, chef: Chef.MINICHEF }));
};

const getFarms = async (network) => {
  const [
    masterChefV1Farms,
    masterChefV2Farms,
    oldMiniChefFarms,
    miniChefFarms,
  ] = await Promise.all([
    (network === "ethereum" ? getMasterChefV1Farms() : Promise.resolve([])),
    (network === "ethereum" ? getMasterChefV2Farms() : Promise.resolve([])),
    (network === "celo" ? getOldMiniChefFarms(network) : Promise.resolve([])),
    (network !== "ethereum" ? getMiniChefFarms(network) : Promise.resolve([])),
  ]);
   
  return concat(masterChefV1Farms, masterChefV2Farms, miniChefFarms, oldMiniChefFarms).filter((pool) => pool && pool.pair);
};

module.exports = {
  miniChef,
  getFarms,
  oldMiniChef,
  masterChefV2,
  masterChefV1,
  getMasterChefV1TotalAllocPoint,
  getMasterChefV1SushiPerBlock,
  getMasterChefV1Farms,
  getMasterChefV1PairAddreses,
  getMasterChefV2Farms,
  getMasterChefV2PairAddreses,
  getOldMiniChefFarms,
  getMiniChefFarms,
  getMiniChefPairAddreses,
};
